var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 10,
    height: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5174 5.54167C21.2761 4.54167 20.5119 3.75 19.5868 3.5C17.8574 3 11.0201 3 11.0201 3C11.0201 3 4.1426 3 2.41316 3.5C1.48812 3.75 0.723949 4.54167 0.482633 5.54167C0 7.29167 0 11.0417 0 11.0417C0 11.0417 0 14.75 0.482633 16.5417C0.723949 17.5417 1.48812 18.2917 2.41316 18.5417C4.1426 19 11.0201 19 11.0201 19C11.0201 19 17.8574 19 19.5868 18.5417C20.5119 18.2917 21.2761 17.5417 21.5174 16.5417C22 14.75 22 11.0417 22 11.0417C22 11.0417 22 7.29167 21.5174 5.54167ZM8.76782 14.4167V7.66667L14.479 11.0417L8.76782 14.4167Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f6c548e4a0bdec0a21e2843f3431c0d2.svg";
export { ForwardRef as ReactComponent };